import React from 'react';
import { Authenticator } from '@aws-amplify/ui-react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import '@aws-amplify/ui-react/styles.css';
import logo from '../../assets/logo.png';

const Login: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #F9F9FE 0%, #EDE7FE 100%)',
        '& [data-amplify-authenticator]': {
          width: '100%',
          maxWidth: 420,
          '--amplify-components-authenticator-router-border-width': '0',
          '--amplify-components-authenticator-router-box-shadow': '0 4px 24px rgba(132, 89, 240, 0.12)',
          '--amplify-components-authenticator-router-background-color': 'white',
          '--amplify-components-authenticator-router-border-radius': '12px',
          '--amplify-components-button-primary-background-color': '#8459f0',
          '--amplify-components-button-primary-hover-background-color': '#6B4EFF',
          '--amplify-components-button-primary-active-background-color': '#5a3dd6',
          '--amplify-components-button-primary-focus-background-color': '#8459f0',
          '--amplify-components-button-primary-border-radius': '8px',
          '--amplify-components-fieldcontrol-focus-border-color': '#8459f0',
          '--amplify-components-tabs-item-active-color': '#8459f0',
          '--amplify-components-tabs-item-active-border-color': '#8459f0',
          '--amplify-components-button-link-color': '#8459f0',
          '--amplify-components-button-link-hover-color': '#6B4EFF',
          '--amplify-fonts-default-static': 'Questrial, sans-serif',
        },
      }}
    >
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <Box
          component="img"
          src={logo}
          alt="EVA"
          sx={{ height: 56, mb: 2 }}
        />
        <Typography variant="h5" fontWeight={700} color="#1A1A2E">
          Help Center Admin
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          Sign in to manage help articles and content
        </Typography>
      </Box>
      <Authenticator
        hideSignUp={true}
        components={{
          Header: () => <></>,
        }}
      >
        {({ user }) => {
          if (user) {
            navigate('/admin');
          }
          return <></>;
        }}
      </Authenticator>
    </Box>
  );
};

export default Login;
